/**
 * Scroll Animation Utilities
 * Handles scroll-triggered animations and counter animations
 */
export const initScrollAnimations = () => {
  // Counter animation function
  const animateCounter = (container) => {
    const counterElement = container.querySelector('.counter');
    if (!counterElement) return;
    
    const targetValue = parseInt(counterElement.getAttribute('data-target'));
    const duration = 2000;
    const increment = targetValue / (duration / 16);
    let currentValue = 0;

    const updateCounter = () => {
      currentValue += increment;
      if (currentValue < targetValue) {
        counterElement.textContent = Math.floor(currentValue);
        requestAnimationFrame(updateCounter);
      } else {
        counterElement.textContent = targetValue;
        counterElement.classList.add('animate');
      }
    };

    updateCounter();
  };

  // Intersection Observer for scroll-triggered animations
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animated');
        
        // Trigger counter animations for all counters in this section
        const counters = entry.target.querySelectorAll('.counter-container');
        counters.forEach(counter => {
          if (!counter.classList.contains('animated')) {
            counter.classList.add('animated');
            animateCounter(counter);
          }
        });
      }
    });
  }, observerOptions);

  // Observe all elements with animate-on-scroll class
  const animatedElements = document.querySelectorAll('.animate-on-scroll');
  animatedElements.forEach(el => observer.observe(el));
};

/**
 * Initialize scroll animations when DOM is loaded
 */
export const setupScrollAnimations = () => {
  // Small delay to ensure DOM is fully rendered
  setTimeout(() => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initScrollAnimations);
    } else {
      initScrollAnimations();
    }
  }, 100);
};
